var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaqIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM6.21347 6.29249C6.59592 6.51372 7.0853 6.38303 7.30654 6.00058C8.07214 4.89232 9.55205 6.368 8.33868 7.08932C8.12059 7.21897 7.83537 7.43478 7.61843 7.69915C7.41302 7.94948 7.22436 8.29373 7.20218 8.71682C7.19935 8.74416 7.1979 8.77191 7.1979 8.8C7.1979 9.24183 7.55608 9.6 7.9979 9.6C8.60772 9.6 8.72379 9.27603 8.84092 8.94912C8.91627 8.73881 8.99206 8.52729 9.2 8.4C9.86129 7.99519 10.4 7.27818 10.4 6.4C10.4 5.07452 9.32548 4 8 4C7.11065 4 6.33533 4.48415 5.92157 5.19942C5.70033 5.58187 5.83102 6.07125 6.21347 6.29249ZM7.1979 11.2C7.1979 10.7582 7.55608 10.4 7.9979 10.4C8.43973 10.4 8.7979 10.7582 8.7979 11.2C8.7979 11.6418 8.43973 12 7.9979 12C7.55608 12 7.1979 11.6418 7.1979 11.2Z",
    fill: "url(#paint0_radial_9537_5754)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_9537_5754",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8 8) rotate(90) scale(8)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC2D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8ADC7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqIcon);
export default __webpack_public_path__ + "static/media/faq-icon.c1134d0894c05e89e617d6ed3061823a.svg";
export { ForwardRef as ReactComponent };